module.exports = __webpack_public_path__ + "static/snc-cf549d5c64f2875567a1693abc93f979.png";